import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import './cardHome.scss';
import { ListarVendas } from '../../../../components/modals';

function CardHome({
  item: {
    titulo, imagem, descricao, valid, route, isModal,
  },
}) {
  const history = useHistory();
  const [classMouseOver, setClassMouseOver] = useState('sizeUp');
  return (
    <div id="content-card">
      <ListarVendas />
      <div className="img-card">
        <button
          className={`${classMouseOver}`}
          onMouseOver={() => !valid && setClassMouseOver('sizeUp')}
          onFocus={() => {}}
          onMouseOut={() => !valid && setClassMouseOver('sizeDown')}
          onBlur={() => {}}
          onClick={() => !isModal && (!valid && history.push(route))}
          type="button"
          data-toggle="modal"
          data-target="#modal-vendas"
          disabled={valid}
        >
          <img src={imagem} alt={titulo} />
        </button>
      </div>
      <div className="titulo-card">
        <span>
          {titulo}
        </span>
      </div>
      <div className="descricao-card">
        <span>
          {descricao}
        </span>
      </div>
    </div>
  );
}

CardHome.propTypes = {
  item: PropTypes.shape.isRequired,
};

export default CardHome;
